module.exports = window.__loadPromiseRequirejs__("stylable-panel");